import { Component, OnInit, inject } from '@angular/core';
import { SharedSignalsService } from '../../../common/services/shared-signals.service';
import { FaqService } from '../../../faq/services/faq.service';
import { Item } from '../../../common/models/faq.model';
@Component({
  selector: 'taly-partner-faq',
  templateUrl: './partner-faq.component.html',
  styleUrls: ['./partner-faq.component.scss'],
  providers: [FaqService],
  standalone: false,
})
export class PartnerFaqComponent implements OnInit {
  transferSignal = inject(SharedSignalsService);
  public faqService = inject(FaqService);

  faqList: Item[] = [];
  activeIndex: number | undefined;
  isActive: boolean = false;

  ngOnInit(): void {
    this.getFAQs();
  }

  toggleActive() {
    this.isActive = !this.isActive;
  }

  getFAQs() {
    const categories = 'PARTNER';

    this.faqService.getFAQList(categories).subscribe(
      (resp) => {
        if (resp?.length > 0) {
          this.faqList = resp[0].section[0]?.itemList.slice(0, 5);
        } else {
          this.faqList = [];
        }
      },
      (err) => {
        this.transferSignal.showMessage('error', err?.message || err);
      }
    );
  }
}
